// extracted by mini-css-extract-plugin
export default {"container":"qQ-z","modal":"rQ-z","dimensions":"sQ-z","brandName":"tQ-z","productName":"uQ-z","labelValue":"vQ-z","recipientEmail":"wQ-z","recommendedFit":"xQ-z","hiddenField":"yQ-z"};